import React from 'react'
import classNames from 'classnames'

export const Switch = ({
  label = '',
  disabled = false,
  checked = false,
  onChange = () => {},
  ...props
}) => {

  let switchClassNames = []
  let checkedClassNames = []
  let colorClassNames = []

  if (disabled) {
    switchClassNames.push('cursor-not-allowed')
    checkedClassNames.push('bg-gray-300')
  }

  if (checked) {
    checkedClassNames.push('translate-x-5')
    colorClassNames.push( disabled ? 'bg-gray-300' : 'bg-primary')
  } else {
    checkedClassNames.push('translate-x-0')
    colorClassNames.push('bg-gray-200')
  }

  return (
    <div 
      className={classNames([
        'flex',
        'items-center',
      ])}
    >

        <button 
          disabled={disabled} 
          type="button" 
          className={classNames([
            'shrink-0',
            'group',
            'relative',
            'rounded-full',
            'inline-flex',
            'items-center',
            'justify-center',
            'h-5',
            'w-10',
            'cursor-pointer',
            'focus:outline-none',
            'focus:ring-2',
            'focus:ring-offset-2',
            'focus:ring-primary',
          ], switchClassNames)} 
          aria-pressed="false" 
          onClick={onChange}
          {...props}
        >
          <span 
            aria-hidden="true" 
            className={classNames([
              'pointer-events-none',
              'absolute',
              'bg-white',
              'w-full',
              'h-full',
              'rounded-full',
            ], colorClassNames)}
          ></span>
          <span
            aria-hidden="true" 
            className={classNames([
              'pointer-events-none',
              'absolute',
              'h-4',
              'w-9',
              'mx-auto',
              'rounded-full',
              'transition-colors',
              'ease-in-out',
              'duration-200',
            ], checkedClassNames)}
          ></span>
          <span 
            aria-hidden="true" 
            className={classNames([
              'pointer-events-none',
              'absolute',
              'left-0',
              'inline-block',
              'h-5',
              'w-5',
              'border',
              'border-gray-200',
              'rounded-full',
              'bg-white',
              'shadow',
              'transform',
              'ring-0',
              'transition-transform',
              'ease-in-out',
              'duration-200',
            ], checkedClassNames)}
          ></span>
      </button>

      <p 
        className={classNames([
          'text-base',
          'font-normal',
          'mx-2'
        ])}
      >
        { label }
      </p>
    </div>
  )
}

export default Switch
